export default __webpack_public_path__ + "static/media/work6.639e20cf.png";